module.exports = __webpack_public_path__ + "static/media/show_details_past.25a916d2.svg";